import React from 'react';
import proptypes from 'prop-types';
import { MenuItem } from '@one-thd/sui-atomic-components';
import { Card } from '../card/card';
import { DropdownItem } from '../dropdown/dropdown-item';
import { Swatch } from '../swatch/swatch';
import { Tile } from '../tile/tile';

const {
  bool, func, oneOf, shape, string
} = proptypes;

export const SuperSkuAttributeValue = ({
  attributeType,
  channel,
  centeredCards = false,
  displayInToolTip = false,
  hexColor = '',
  hoveredCombinationDetails = {},
  isAvailable,
  isDotComColorEligible = false,
  isFabricType = false,
  isSelected,
  isTooltipsEnabled = false,
  miniSwatch = false,
  onClick,
  onMouseEnter = () => {},
  onMouseLeave = () => {},
  swatchCardCombinationDetails = {},
  swatchGuid = '',
  value,
  attributeName = '',
  paintBrand = '',
  isPaintReorder = false,
  isOOS = false,
  isUnavailable = false,
  unavailableTooltipMessage = '',
  oosTooltipMessage = '',
}) => {

  const isCard = attributeType === 'card';
  const isDropdown = attributeType === 'dropdown';
  const isSwatch = attributeType === 'swatch';
  const isTile = attributeType === 'tile';

  return (
    <>
      {isSwatch
      && (
        <Swatch
          isSelected={isSelected}
          isAvailable={isAvailable}
          value={value}
          swatchGuid={swatchGuid}
          onClick={onClick}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          isTooltipsEnabled={isTooltipsEnabled}
          hoveredCombinationDetails={hoveredCombinationDetails}
          channel={channel}
          miniSwatch={miniSwatch}
          displayInToolTip={displayInToolTip}
          isOOS={isOOS}
          isUnavailable={isUnavailable}
          unavailableTooltipMessage={unavailableTooltipMessage}
          oosTooltipMessage={oosTooltipMessage}
        />
      )}
      {isTile
      && (
        <Tile
          isSelected={isSelected}
          isAvailable={isAvailable}
          isFabricType={isFabricType}
          value={value}
          onClick={onClick}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          isTooltipsEnabled={isTooltipsEnabled}
          hoveredCombinationDetails={hoveredCombinationDetails}
          channel={channel}
          isOOS={isOOS}
          isUnavailable={isUnavailable}
          unavailableTooltipMessage={unavailableTooltipMessage}
          oosTooltipMessage={oosTooltipMessage}
        />
      )}
      {isCard
      && (
        <Card
          isSelected={isSelected}
          isDotComColorEligible={isDotComColorEligible}
          attributeValue={value}
          onClick={onClick}
          swatchCardCombinationDetails={swatchCardCombinationDetails}
          centeredCards={centeredCards}
          hexColor={hexColor}
          attributeName={attributeName}
          paintBrand={paintBrand}
          isPaintReorder={isPaintReorder}
          channel={channel}
        />
      )}
      {
        isDropdown && (
          <MenuItem
            value={value}
            onClick={onClick}
          >
            <DropdownItem
              swatchGuid={swatchGuid}
              attributeValue={value}
              isDisabled={!isAvailable}
            />
          </MenuItem>
        )
      }
    </>
  );
};

SuperSkuAttributeValue.displayName = 'SuperSkuAttributeValue';

SuperSkuAttributeValue.propTypes = {
  attributeType: string.isRequired,
  channel: oneOf(['desktop', 'mobile']).isRequired,
  centeredCards: bool,
  displayInToolTip: bool,
  hexColor: string,
  hoveredCombinationDetails: shape({}),
  isAvailable: bool.isRequired,
  isDotComColorEligible: bool,
  isFabricType: bool,
  isSelected: bool.isRequired,
  isTooltipsEnabled: bool,
  miniSwatch: bool,
  onClick: func.isRequired,
  onMouseEnter: func,
  onMouseLeave: func,
  swatchCardCombinationDetails: shape({}),
  swatchGuid: string,
  value: string.isRequired,
  attributeName: string,
  paintBrand: string,
  isPaintReorder: bool,
  isOOS: bool,
  isUnavailable: bool,
  unavailableTooltipMessage: string,
  oosTooltipMessage: string,
};
